import React from 'react';

import { Typography } from '../../designComponents';
import { blueprintData } from '../../pages/LandingPage/BlueprintDevelopment/data';
import Details from '../../pages/LandingPage/BlueprintDevelopment/Details';
import theme from '../../theme';
import Role from './Role';
import { rolesData } from './roles';
import { DiscoverSectionStyled } from './style';

type Props = {};

const DiscoverUs = (_props: Props) => {
  return (
    <DiscoverSectionStyled>
      <div className="discover-us">
        <Typography size={20} style={{ color: '#20435D', fontWeight: '600' }}>
          DISCOVER US
        </Typography>
        <Typography
          color="primary"
          size={14}
          style={{ color: '#1D8960', fontWeight: '500' }}
        >
          What is Escape Plan ?
        </Typography>
        <Typography style={{ fontWeight: '500' }}>Roles</Typography>
        <Typography style={{ fontWeight: '500' }}>
          Process for Blueprint Development
        </Typography>
        <Typography style={{ fontWeight: '500' }}>Our Mission</Typography>
      </div>
      <div className="escape-plan">
        <div className="first-section">
          <Typography size={32} className="title">
            <span style={{ color: '#20435D' }}>What is</span>{' '}
            <span style={{ color: '#1D8960' }}>Escape Plan</span> ?
          </Typography>

          <Typography size={16}>
            Escapeplan is a premier provider of blueprint services, specializing
            in delivering precise and compliant CAD files and PDF escape plans
            tailored to your building's unique specifications.
          </Typography>

          <Typography size={16}>
            Led by our skilled team of AutoCAD technicians, we meticulously
            convert building drawings into professional blueprints, ensuring
            accuracy and compliance with regulatory standards. With a focus on
            efficiency and precision, we streamline the process to provide
            prompt delivery without compromising on quality.
          </Typography>

          <Typography size={16}>
            Trust Escapeplan for all your blueprint services, and let us bring
            your building plans to life with expertise and dedication.
          </Typography>
        </div>
        <div className="first-section">
          <Typography size={32} className="title">
            <span style={{ color: '#20435D' }}>Roles in</span>{' '}
            <span style={{ color: '#1D8960' }}>Escape Plan</span>
          </Typography>

          <Typography size={16}>
            In the Escape Plan system, clients initially add buildings, then
            create jobs for technicians and escape plan professionals.
            Technicians and professionals review job details and send proposals
            to clients, who accept or reject based on terms and offers. Upon
            acceptance and contract receipt, technicians commence drawing. Upon
            completion, they send the PDF to admins, who can review themselves
            or assign to firemen or draftsmen. Admins report issues to
            technicians for rework until PDF completion. After approval,
            technicians send the PDF to clients, who then send it to printers or
            create printer jobs.
          </Typography>
        </div>
        <div
          style={{
            backgroundColor: theme.colors.greeenfadeLight,
            display: 'flex',
            flexDirection: 'column',
            gap: '30px',
            padding: '30px',
            borderRadius: '5px',
          }}
        >
          {rolesData?.map((role, idx) => (
            <div key={idx}>
              <Role label={role.label} id={idx + 1} />
              {role.desc?.map((item, index) => (
                <Role key={index} des={item?.des} />
              ))}
            </div>
          ))}
        </div>
        <div className="first-section">
          <Typography size={32} className="title">
            Process for Blueprint Development
          </Typography>

          <Typography size={16}>
            In today's fast-paced world, navigating complex processes can be
            daunting. That's why at EscapePlan, we've designed a straightforward
            and intuitive approach to building blueprint creation. Our
            streamlined process eliminates unnecessary steps, making it easy for
            clients to convert their building drawings into precise and
            compliant plans.
          </Typography>
        </div>
        <div
          style={{
            backgroundColor: theme.colors.greeenfadeLight,
            display: 'flex',
            flexDirection: 'column',
            padding: '30px',
            borderRadius: '5px',
          }}
        >
          {blueprintData.map((data, idx) => (
            <Details
              id={idx + 1}
              desc={data.desc}
              label={data.label}
              key={idx}
            />
          ))}
        </div>
        <div className="first-section">
          <Typography size={32} className="title">
            Our Mission
          </Typography>

          <Typography size={16}>
            At Escapeplan, our mission extends beyond ordinary fire escape
            planning services. We are dedicated to being your trusted ally in
            providing precision blueprint solutions that exceed industry
            standards. Our goal is to deliver accurate and compliant CAD files
            and PDF escape plans meticulously tailored to the unique
            specifications of your building. With a focus on precision,
            compliance, and client satisfaction, we strive to ensure that every
            blueprint we produce meets the highest standards of quality and
            reliability.
          </Typography>
        </div>
      </div>
    </DiscoverSectionStyled>
  );
};

export default DiscoverUs;
